import React from 'react';

export default function AddButton({
  disabled,
  onClick,
}: {
  disabled: boolean;
  onClick: () => void;
}): React.JSX.Element {
  return (
    <button
      style={{
        borderRadius: '10px',
      }}
      disabled={disabled}
      onClick={onClick}
      className='w-full flex border-2 border-gray-200 font-medium text-sm p-4'
    >
      Add bank account
    </button>
  );
}
